export default __webpack_public_path__ + "static/media/Mail.b49271c8.svg";